"use client";

import PropTypes from "prop-types";
import { AlertFilled as AlertIcon } from "@churchofjesuschrist/eden-icons";
import { accentColorDanger } from "@churchofjesuschrist/eden-style-constants";
import Alert from "./Alert";

/**
 * Displays information in a styled box with color and icon associated to an error.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const Error = ({
  children,
  title,
  renderTitleAs = "h2",
  ...props
}) => /*#__PURE__*/_jsx(Alert, {
  ...props,
  Icon: AlertIcon,
  color: accentColorDanger,
  title: title,
  renderTitleAs: renderTitleAs,
  children: children
});
Error.displayName = "Error";
Error.propTypes = {
  /** Content inside the alert body */
  children: PropTypes.node.isRequired,
  /** Callback function to execute when user dismisses the alert */
  onClose: PropTypes.func,
  /** Label for the "close" control. */
  closeLabel: PropTypes.string,
  /** Optional title for the content inside the alert. Will be rendered as an \<H2\>, \<H3\>, \<H4\>, \<H5\>, or \<H6\>. */
  title: PropTypes.string,
  /** The title will be rendered at the selected level. */
  renderTitleAs: PropTypes.oneOf(["h2", "h3", "h4", "h5", "h6"])
};
export default Error;